(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kinriot-article-product-entry"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeEntries = () => {
      document.querySelectorAll('template[data-kinriot-article-entry]').forEach((template) => {
        if (template.dataset.ready) return;
        const root = document.getElementById(template.dataset.articleRoot);
        const prose = root?.querySelector('[data-article-content]');
        if (!prose || prose.querySelector('.kinriot-article-product-entry')) return;
        const paragraph = Array.from(prose.querySelectorAll('p')).find((item) =>
          !item.closest('nav, table, aside') && item.textContent.includes(template.dataset.marker)
        );
        if (!paragraph) return;
        const existing = Array.from(prose.querySelectorAll('a[href]')).find((link) => {
          const url = new URL(link.href, window.location.href);
          return url.origin === window.location.origin && url.pathname === template.dataset.productPath;
        });
        template.dataset.ready = 'true';
        if (existing && (paragraph.contains(existing) || !(paragraph.compareDocumentPosition(existing) & Node.DOCUMENT_POSITION_FOLLOWING))) return;
        paragraph.after(template.content.cloneNode(true));
      });
    };
    initializeEntries();
    document.addEventListener('shopify:section:load', initializeEntries);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kinriot-mobile-purchase-return"] && !Shopify.designMode) return;
  try {
    (() => {
    const bars = new Set();
    const mobile = window.matchMedia('(max-width: 749px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let pending = false;
    let observedChat;
    let observedBanner;

    const visibleRect = (element) => {
      if (!element) return null;
      const style = getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      return style.visibility !== 'hidden' && Number(style.opacity) > 0 && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight ? rect : null;
    };

    const refresh = () => {
      pending = false;
      const chat = document.querySelector('shopify-chat');
      const banner = document.getElementById('shopify-pc__banner');
      if (chat && chat !== observedChat) {
        observedChat = chat;
        new MutationObserver(schedule).observe(chat, { attributes: true, attributeFilter: ['open', 'mode'] });
      }
      if (banner && banner !== observedBanner) {
        observedBanner = banner;
        new ResizeObserver(schedule).observe(banner);
        new MutationObserver(schedule).observe(banner, { attributes: true, attributeFilter: ['style', 'hidden', 'class'] });
      }
      const runtime = chat?.shadowRoot?.querySelector('shopify-agent-runtime');
      const launcher = chat?.shadowRoot?.querySelector('[part~="activator"]') || runtime?.shadowRoot?.querySelector('[part~="activator"]');
      const launcherRect = !chat?.hasAttribute('open') && visibleRect(launcher?.parentElement || launcher);
      const bannerRect = visibleRect(banner);
      let bottom = chat ? 80 : 9;
      for (const rect of [launcherRect, bannerRect]) {
        if (rect) bottom = Math.max(bottom, innerHeight - rect.top + 12);
      }
      const headerBottom = Math.max(0, document.getElementById('header-group')?.getBoundingClientRect().bottom || 0);
      for (const item of bars) {
        if (!item.bar.isConnected) { bars.delete(item); continue; }
        const inset = `${Math.ceil(bottom)}px`;
        if (item.bar.style.getPropertyValue('--kinriot-sticky-bottom') !== inset) item.bar.style.setProperty('--kinriot-sticky-bottom', inset);
        item.bar.classList.toggle('is-visible', mobile.matches && item.trigger.getBoundingClientRect().bottom <= headerBottom);
      }
    };

    function schedule() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(refresh);
    }

    const initialize = () => {
      document.querySelectorAll('[data-mobile-sticky]').forEach((bar) => {
        if (bar.dataset.returnReady) return;
        const root = bar.closest('.kinriot-rtw, .kinriot-int');
        const trigger = root?.querySelector('[data-add-button]');
        const options = root?.querySelector('[data-purchase-options]');
        const link = bar.querySelector('[data-sticky-return]');
        if (!trigger || !options || !link) return;
        bar.dataset.returnReady = 'true';
        bars.add({ bar, trigger });
        link.addEventListener('click', (event) => {
          event.preventDefault();
          options.focus({ preventScroll: true });
          options.scrollIntoView({ block: 'start', behavior: reducedMotion.matches ? 'instant' : 'smooth' });
        });
        new ResizeObserver(schedule).observe(root);
        new IntersectionObserver(schedule).observe(trigger);
      });
      schedule();
    };

    document.addEventListener('scroll', schedule, { passive: true, capture: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('load', schedule, { once: true });
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('shopify:section:load', initialize);
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    initialize();
  })();
  } catch(e) { console.error(e); }
})();

})();
